(function () {
  const SLIDER_SELECTOR = '[data-shop-by-goal-slider]';

  // On mobile the slider bleeds to both screen edges. CSS can only guess that bleed with 100vw,
  // which counts the scrollbar and pushes the last card past the visible edge, so measure the
  // real gutter from the wrapper that sits inside .page-width's padding box.
  //
  // Only mobile bleeds. Above 750px .page-width caps the content at --page-width, so the same
  // measurement returns the whole desktop gutter (e.g. 170px on a 1700px screen) and that used to
  // be written to slidesOffsetAfter — phantom scroll room that left the next arrow live and slid
  // the row sideways even when every card already fit.
  //
  // Goals grid reuses this script for its slider, so both section wrappers are accepted here.
  function updateBleed(sliderEl) {
    const wrapper = sliderEl.closest('.shop-by-goal-wrapper, .goals-grid-wrapper');
    const mainWrapper = sliderEl.closest('.swiper-main-wrapper');

    if (!wrapper || !mainWrapper) return;

    const bleeds =
      (wrapper.classList.contains('sbg--mobile-peek') || wrapper.classList.contains('gg--mobile-peek')) &&
      window.matchMedia('(max-width: 749px)').matches;

    let bleed = 0;

    if (bleeds) {
      const contentWidth = mainWrapper.getBoundingClientRect().width;
      const viewportWidth = document.documentElement.clientWidth;

      bleed = Math.max(0, Math.floor((viewportWidth - contentWidth) / 2));
    }

    wrapper.style.setProperty('--sbg-bleed', bleed + 'px');

    // Cards bleed off the screen edge while scrolling, but the last slide stops on the
    // page-width line instead of hard against the viewport edge.
    if (sliderEl.shopByGoalSwiper) {
      sliderEl.shopByGoalSwiper.params.slidesOffsetAfter = bleed;
      sliderEl.shopByGoalSwiper.update();
    }
  }

  function watchBleed(sliderEl) {
    const mainWrapper = sliderEl.closest('.swiper-main-wrapper');

    updateBleed(sliderEl);

    // A plain window "resize" listener misses the theme editor's live preview, which updates
    // --page-width (and therefore the gutter the slider bleeds into) by rewriting a CSS variable
    // in place with no resize event at all. ResizeObserver watches the rendered box instead, so
    // it also re-fires for font-load reflows and drawer toggles.
    if (mainWrapper && typeof ResizeObserver !== 'undefined') {
      let resizeTimer = null;
      const observer = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateBleed(sliderEl);
        }, 100);
      });

      observer.observe(mainWrapper);
      sliderEl.shopByGoalResizeObserver = observer;
    } else {
      window.addEventListener('resize', function () {
        updateBleed(sliderEl);
      });
    }
  }

  function initSlider(sliderEl) {
    if (typeof Swiper === 'undefined') return;
    if (sliderEl.dataset.shopByGoalInit === 'true') return;

    let options = {};

    try {
      options = JSON.parse(sliderEl.dataset.sliderOptions || '{}');
    } catch (error) {
      console.warn('Shop by goal slider: options parse error', error);
    }

    sliderEl.dataset.shopByGoalInit = 'true';
    sliderEl.shopByGoalSwiper = new Swiper(sliderEl, options);

    watchBleed(sliderEl);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  function destroyAll(root) {
    if (!root) return;

    root.querySelectorAll(SLIDER_SELECTOR).forEach(function (sliderEl) {
      if (sliderEl.shopByGoalResizeObserver) {
        sliderEl.shopByGoalResizeObserver.disconnect();
        sliderEl.shopByGoalResizeObserver = null;
      }

      if (sliderEl.shopByGoalSwiper) {
        sliderEl.shopByGoalSwiper.destroy(true, true);
        sliderEl.shopByGoalSwiper = null;
      }

      delete sliderEl.dataset.shopByGoalInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
